import { SimpleGrid, Text } from '@chakra-ui/react';
import MarketCard from '@features/prediction-markets/MarketCard';
import {
  PredictionMarket,
  QUESTION_TO_WEEKLY_SUB,
  TimeCategory,
  WeeklySubCategory,
} from '@features/prediction-markets/types';
import { useHref } from 'hooks/useHref';
import { memo, useMemo } from 'react';

interface Props {
  markets: PredictionMarket[];
  timeCategory: TimeCategory;
  weeklySubCategory: WeeklySubCategory;
  commodityIds: Set<string>;
}

const MarketCardGrid = ({ markets, timeCategory, weeklySubCategory, commodityIds }: Props) => {
  const { predictionMarketHref } = useHref();

  const filtered = useMemo(() => {
    let result = markets;

    if (commodityIds.size > 0) {
      result = result.filter((m) => commodityIds.has(m.commodityId));
    }

    if (timeCategory !== 'all') {
      result = result.filter((m) => m.timeCategory === timeCategory);
    }

    if (timeCategory === 'weekly' && weeklySubCategory !== 'all') {
      result = result.filter(
        (m) => QUESTION_TO_WEEKLY_SUB[m.questionType] === weeklySubCategory,
      );
    }

    return result;
  }, [markets, timeCategory, weeklySubCategory, commodityIds]);

  if (filtered.length === 0) {
    return (
      <Text color="text.secondary" fontSize="sm" p={4}>
        No markets found for this category.
      </Text>
    );
  }

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={4}>
      {filtered.map((market) => (
        <MarketCard
          key={market.id}
          market={market}
          href={predictionMarketHref(market.id)}
        />
      ))}
    </SimpleGrid>
  );
};

export default memo(MarketCardGrid);
